import { BotaoLink } from '../../components/Botao'
import { EstadoVazio } from '../../components/Estados'
import { IconeMudanca, IconeNovo } from '../../components/Icones'
import { Cartao } from '../../components/ListaDeDados'
import { TERMOS, TEXTOS } from '../../lib/glossario'

/**
 * Os três passos do processo, na ordem em que acontecem.
 *
 * Saem do ANEXO XXI e da Regra nº 1 do `CLAUDE.md` — não são uma explicação inventada para
 * preencher a tela. O terceiro é o que o sistema inteiro existe para garantir, e por isso está
 * escrito com todas as letras já no primeiro acesso.
 */
const PASSOS = [
  {
    titulo: 'Abra a solicitação',
    texto:
      'Diga o que muda, em qual sistema e por quê. Ela nasce em rascunho: fica só com você até ser enviada, ' +
      'e dá para preencher aos poucos.',
  },
  {
    titulo: `Envie ao ${TERMOS.cab.rotulo.toLowerCase()}`,
    texto:
      'Com o plano preenchido — o que precisa estar pronto antes, o passo a passo, como desfazer e como se ' +
      'comprova o teste —, a solicitação entra na pauta da reunião.',
  },
  {
    titulo: 'Implante depois de aprovada',
    texto:
      'Nada entra em produção sem a aprovação do comitê. É exigência do Termo de Referência do contrato, e não ' +
      'uma regra deste sistema.',
  },
]

/**
 * O painel de quem ainda não tem nenhuma solicitação neste sistema.
 *
 * Um painel de zeros é tecnicamente correto e não serve para nada: quem abre o sistema pela
 * primeira vez precisa saber o que é uma solicitação de mudança e o que fazer agora, e não que há
 * zero delas em cada uma de quatro caixas. O histórico do sistema anterior continua aparecendo
 * abaixo — a tela está vazia de processo, não de conteúdo.
 *
 * @param props se o servidor declarou que este usuário pode abrir solicitação
 * @returns a orientação inicial
 */
export function PrimeirosPassos({ podeCriar }: { podeCriar: boolean }) {
  return (
    <div className="space-y-4">
      <EstadoVazio
        icone={<IconeMudanca className="h-9 w-9" />}
        titulo={TEXTOS.listaVazia.titulo}
        ajuda={`${TERMOS.gmud.ajuda} ${TEXTOS.listaVazia.ajuda}`}
        acao={
          podeCriar && (
            <BotaoLink to="/gmuds/novo" aparencia="primario">
              <IconeNovo className="h-4 w-4" />
              Abrir a primeira solicitação
            </BotaoLink>
          )
        }
      />

      <Cartao titulo="Como funciona" descricao="Do rascunho à implantação, em três passos.">
        <ol className="space-y-4">
          {PASSOS.map((passo, indice) => (
            <li key={passo.titulo} className="flex gap-3">
              <span
                aria-hidden="true"
                className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-niteroi-700 text-sm font-semibold text-white"
              >
                {indice + 1}
              </span>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-slate-900">{passo.titulo}</h3>
                <p className="mt-0.5 max-w-prose text-sm text-slate-600">{passo.texto}</p>
              </div>
            </li>
          ))}
        </ol>
      </Cartao>
    </div>
  )
}
